export const DEFAULT_MODAL_TITLE = 'COMMON.MODAL_RELATED_ADS_HEADER'

export const DEFAULT_MODAL_DESCRIPTION = {
  COCHES: 'MODAL_RELATED_ADS_COCHES_MESSAGE',
  MOTOS: 'MODAL_RELATED_ADS_MOTOS_MESSAGE'
}
